/**
 * Breakpoint module
 * - Returns the current media breakpoint
 */
;var breakpoint = (function(window) {
    /**
     * Breakpoint, returns the current breakpoint
     * @returns {string|*}
     */
    var breakpoint = function () {
        this.afterElement = window.getComputedStyle ? window.getComputedStyle(document.body, ':after') : false;

        if(!this.afterElement) {
            return;
        }

        this.afterElement = this.afterElement.getPropertyValue('content').replace(/^["']|["']$/g, '');

        return this.afterElement;
    };

    return breakpoint;
})(window);